import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { ConfigProvider } from 'tea-component';
import LoadCmp from '../utils/LoadCmp';

const Platform = LoadCmp(() => import('./platform'));
const Admin = LoadCmp(() => import('./admin'));
const Login = LoadCmp(() => import('./login'));

export default function App() {
  return <ConfigProvider locale="zh">
    <BrowserRouter>
      <Routes>
        <Route path="platform/*" element={<Platform />} />
        <Route path="admin/*" element={<Admin />} />
        <Route path="login" element={<Login />} />
        <Route path=":id" element={<NavigateToPlatform />} />
        <Route path="/" element={<Navigate to={`platform${window.location.search}`} />} />
      </Routes>
    </BrowserRouter>
  </ConfigProvider>;
}

function NavigateToPlatform() {
  const { id } = useParams();
  return <Navigate to={`/platform/game?id=${id}`} />;
}
